const env = process.env.REACT_APP_ENV;

const productionHost = "foundation.ainft.com";

const Config = {
    version: 'v 1.1.4',
    newProposalShowId: 4,
    newProposalId: 4,
    chain: {
        privateKey: '01',
        fullHost: 'https://api.trongrid.io'
    },
    trongrid: {
        host: 'https://api.trongrid.io',
        key: '10f9f868-d5a6-4fb5-a268-fb1a490ba9f9'
    },
    service: {
        host: 'https://api.apenft.org',
        // host: 'https://api.just.network',
        marketsPath: '/justlend/markets',
        userPath: '/justlend/account',
        dashboardPath: '/dashboard',
        jtokenDetailsPath: '/jtokenDetails',
        govPath: '/apenft/gov',
        proposalListPath: '/proposalList',
        voteStatusPath: '/voteStatus',
        basePath: '/defi/baseInfo',
        tronLinkHost: '',
        balancePath: '/api/wallet/balance',
        getTime: '/defi/baseInfo',
        yieldInfos: '/justlend/yieldInfos',
        tronBull: '/sunProject/tronbull',
        tronbullish: '/sunProject/tronbullish'
    },
    startTime: 1607344200000, // 2020-12-07 20:30:00 1607344200000
    // startTime: Date.now() + 5000, // 2020-12-07 20:30:00 1607344200000
    tronscanUrl: 'https://tronscan.io/#',
    sunUrl: 'https://sun.io/',
    whitePaperEn: 'https://www.justlend.org/docs/justlend_whitepaper_en.pdf',
    whitePaperCn: 'https://www.justlend.org/docs/justlend_whitepaper_cn.pdf',
    reportEn: '',
    reportCn: '',
    APIEn: 'https://www.justlend.org/docs/justlend_api_en.pdf',
    APICn: 'https://www.justlend.org/docs/justlend_api_cn.pdf',
    helpEn: 'https://justlendorg.zendesk.com/hc/en-us',
    helpCn: 'https://justlendorg.zendesk.com/hc/zh-cn',
    twitter: 'http://twitter.com/DeFi_JUST',
    telegram: 'https://t.me/officialjustlend',
    learnMoreEn: 'https://justlendorg.zendesk.com/hc/en-us/articles/360053116771',
    learnMoreCn: 'https://justlendorg.zendesk.com/hc/zh-cn/articles/360053116771',
    contract: {
        unitroller: 'TGjYzgCyPobsNS9n6WcbdLVR9dH7mWqFx7',
        poly: 'TXTXGyhNLhELNZPDXsn5fCnGYLZoLwJvRC',
        JST: 'TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9',
        WJSTAddress: 'TCczUFrX1u4v1mzjBVXsiVyehj1vCaNxDt',
        // nft
        // 线上环境用
        governorAlphaAddress: 'TCaidizY5P2mX2PMwjLarrawBzv8MGyWTv',
        NFT: 'TFczxzPhnThNSqr5by8tvxsdCFRRz6cPNq',
        WNFTAddress: 'TDsVDWKYgtidmsE4jQ8yogo5GqApYDMpML',

        // 测试环境用
        // governorAlphaAddress: 'TVor5CPM7mna3gCdip4hAck5CGVwahzoAq',
        // NFT: 'TSuXZ3yPFm37jSaSbSxuEtn9CbfhE45RzY',
        // WNFTAddress: 'TRh2ta4HY17V4YraxuK3hAtfD697ZKpH5S',

    },
    yielders: [
        {
            pool: 'TE2RzoSV3wFK99w6J9UnnZ4vLfXYoxvRwP',
            sunSupply: 8400,
            day: 14
        },
        {
            pool: 'TXJgMdjVX5dKiQaUi9QobwNxtSQaFqccvd',
            sunSupply: 8400,
            day: 14
        },
        {
            pool: 'TL5x9MtSnDy537FXKx53yAaHRRNdg9TkkA',
            sunSupply: 2800,
            day: 14
        },
        {
            pool: 'TGBr8uh9jBVHJhhkwSJvQN2ZAKzVkxDmno',
            sunSupply: 2800,
            day: 14
        },
        {
            pool: 'TRg6MnpsFXc82ymUPgf5qbj59ibxiEDWvv',
            sunSupply: 2800,
            day: 14
        },
        {
            pool: 'TLeEu311Cbw63BcmMHDgDLu7fnk9fqGcqT',
            sunSupply: 2800,
            day: 14
        },
        {
            pool: 'TWQhCXaWz4eHK4Kd1ErSDHjMFPoPc9czts',
            sunSupply: 2800,
            day: 14
        },
        {
            pool: 'TUY54PVeH6WCcYCd6ZXXoBDsHytN9V5PXt',
            sunSupply: 2800,
            day: 14
        },
        {
            pool: 'TR7BUFRQeq1w5jAZf1FKx85SHuX6PfMqsV',
            sunSupply: 2100,
            day: 14
        }
    ],
    justSwap: 'https://justswap.io/',
    zeroAddr: 'T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb',
    blockPerYear: 10512000,
    defaultPrecision: 1e6,
    tokenDefaultPrecision: 1e6,
    maxBalanceLength: 3,
    voteMaxNum: 19999800000000,
    trxLeft: 40,
    safeMaxRate: 0.8,
    feeLimit: 100000000,
    ethStartTime: 1608640200000,
    currency: [
        {
            symbol: 'BTT',
            name: 'BTT'
        },
        {
            symbol: 'JST',
            name: 'JUST'
        },
        {
            symbol: 'TRX',
            name: 'TRON'
        },
        {
            symbol: 'SUNOLD',
            name: 'SUNOLD'
        },
        {
            symbol: 'WIN',
            name: 'WINK'
        },
        {
            symbol: 'BTCST',
            name: 'Bitcoin Standard Hashrate Token'
        },
        {
            symbol: 'NFT',
            name: 'NFT'
        },
        {
            symbol: 'YFX',
            name: 'YFX'
        }
    ],
    centuryStart: 1615206600000, // 2021-03-08 20:30:00
    centuryRealStart: 1615208400000, // 2021-03-08 21:00:00
    startTime1: 1616418000000
};

let devConfig = {};
if (env === 'test' || productionHost !== window.location.host) {
    devConfig = {
        newProposalShowId: 4,
        newProposalId: 6,
        chain: {
            privateKey: '01',
            // fullHost: 'https://api.nileex.io'
            fullHost: 'https://api.shasta.trongrid.io'
        },
        contract: {
            unitroller: 'TPdWn5nRLxx8n2WKbBZ3FkBejVdiTUGDVM',
            poly: 'TBj45kXsnXAr3DeC4Np3J6WDxDtVh9qESs',
            // JST: 'TF17BgPaZYbz8oxbjhriubPDsA7ArKoLX3',
            // WJSTAddress: 'THBZJT3heBUTqYdaDdPbhgasAoitDeojLG',
            // governorAlphaAddress: 'TABdyfNoFcP1vkNoczy9qK8G8RiBf711K8',
            // NFT
            NFT: 'TSuXZ3yPFm37jSaSbSxuEtn9CbfhE45RzY',
            WNFTAddress: 'TRh2ta4HY17V4YraxuK3hAtfD697ZKpH5S',
            governorAlphaAddress: 'TVor5CPM7mna3gCdip4hAck5CGVwahzoAq',
        },
        yielders: [
            {
                pool: 'TDchKqQ8T2BhGfL7m2DfWfxp5eqa1we5hu',
                sunSupply: 8400,
                day: 14
            },
            {
                pool: 'TTUtHMoRLR97C3kd6gyGPWb1ReCWDcRAyA',
                sunSupply: 8400,
                day: 14
            },
            {
                pool: 'TTYKZf1Vv3sKED5LSKGh9Yi2XwJxam9nqj',
                sunSupply: 2800,
                day: 14
            },
            {
                pool: 'TSdWpyV2Z8YdJmsLcwX3udZTTafohxZcVJ',
                sunSupply: 2800,
                day: 14
            },
            {
                pool: 'TJRXoWa5CiG7ZRf36ncEXDLUoMbEuH3ZJs',
                sunSupply: 2800,
                day: 14
            },
            {
                pool: 'TXjnpsP7FWCGZWzrFbXsQcpgyKd26v45dK',
                sunSupply: 2800,
                day: 14
            },
            {
                pool: 'TCby9165NKLydYDJEQ1RTUdJ3VoFXq8VVs',
                sunSupply: 2800,
                day: 14
            },
            {
                pool: 'TDYhBGVRwRCyvnfsnLrwtj1xWEsoPKVWKz',
                sunSupply: 2800,
                day: 14
            },
            {
                pool: 'TJg1msVTDbv5wma5t5wDJKqDHAH4BzC85i',
                sunSupply: 2800,
                day: 14
            }
        ],
        // tronscanUrl: 'https://nile.tronscan.io/#',
        tronscanUrl: 'https://shasta.tronscan.org/#',
        sunUrl: 'http://123.56.166.152:18109',
        // justSwap: 'http://123.56.166.152:18096/',
        service: Object.assign(Config.service, {
            host: 'http://123.56.166.152:10088',
            tronLinkHost: 'http://18.218.162.80:8088'
        }),
        startTime: Date.now() + 5 * 1000,
        ethStartTime: Date.now() + 10 * 1000,
        centuryStart: Date.now() - 20 * 1000, // 模拟 2021-03-08 20:30:00
        centuryRealStart: Date.now() - 60 * 1000, // 模拟 2021-03-08 21:00:00
        startTime1: Date.now() + 10000 // 模拟 2021-03-22 21:00
    };
}
export default Object.assign(Config, devConfig);
